import React from 'react';

const OptInSwitch = ({ label, checked, onChange, id = "opt-in-switch" }) => {
  return (
    <label style={styles.container} htmlFor={id}>
      <span style={styles.label}>{label}</span>
      <div style={styles.switchWrapper}>
        <input
          id={id}
          type="checkbox"
          checked={checked}
          onChange={onChange}
          style={styles.hiddenCheckbox}
        />
        <div style={{ ...styles.switch, ...(checked ? styles.switchChecked : {}) }}>
          <div style={{ ...styles.thumb, ...(checked ? styles.thumbChecked : {}) }} />
        </div>
      </div>
    </label>
  );
};

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    cursor: 'pointer',
    userSelect: 'none',
  },
  label: {
    fontSize: '1rem',
    fontWeight: 500,
    color: 'var(--text-primary)',
    marginRight: '1rem',
  },
  switchWrapper: {
    position: 'relative',
  },
  hiddenCheckbox: {
    opacity: 0,
    width: 0,
    height: 0,
    position: 'absolute',
  },
  switch: {
    width: '50px',
    height: '28px',
    backgroundColor: 'var(--secondary)',
    borderRadius: '14px',
    display: 'flex',
    alignItems: 'center',
    padding: '3px',
    transition: 'background-color 0.3s ease',
  },
  switchChecked: {
    backgroundColor: 'var(--success)',
  },
  thumb: {
    width: '22px',
    height: '22px',
    backgroundColor: 'white',
    borderRadius: '50%',
    boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
    transition: 'transform 0.3s ease',
    transform: 'translateX(0)',
  },
  thumbChecked: {
    transform: 'translateX(22px)',
  },
};

export default OptInSwitch;
